import { isUndefined } from 'lodash';
import reportTypes, { ReportTypes } from '../../constants/reportTypes';
import Joi from '../joiExtension';

export type Attributes = {
  type: ReportTypes | ReportTypes[];
} | undefined;

export const attributesSchema = Joi.object<Attributes>().keys({
  type: Joi.alternatives(
    Joi.string().valid(...Object.values(reportTypes)),
    Joi.array().items(Joi.string().valid(...Object.values(reportTypes))),
  ).required(),
});

export const cleanPermissionAttributes = (value: {
  attributes: unknown;
  isFilteringAttributes?: string;
}) => {
  if (value.isFilteringAttributes === 'yes') return value.attributes;
  return undefined;
};

export const checkIsTypeAllowed = (type: ReportTypes) => (
  matchingPermissions: { attributes: Attributes }[],
) => matchingPermissions.some((matchingPermission) => {
  if (isUndefined(matchingPermission.attributes)) return true;
  if (Array.isArray(matchingPermission.attributes.type)) {
    return matchingPermission.attributes.type.includes(type);
  }
  return matchingPermission.attributes.type === type;
});
